// React error boundary for the recorder. Catches render-time errors and
// forwards them to the upload-server telemetry sink. Renders a minimal
// fallback so testers can recover with a reload.
import React from 'react';
import { trackError } from './telemetry';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error && error.message ? error.message : 'Unknown error' };
  }

  componentDidCatch(error, info) {
    try {
      trackError(error, {
        componentStack: info && info.componentStack ? String(info.componentStack).slice(0, 2000) : undefined,
        boundary: 'recorder-root',
        recording_session_id:
          typeof window !== 'undefined' && window.__rsid ? window.__rsid : undefined
      });
    } catch (_e) {
      // Swallow — telemetry must never break the fallback UI.
    }
  }

  handleReload = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          style={{
            padding: '24px',
            margin: '24px',
            border: '1px solid #f44336',
            borderRadius: '8px',
            backgroundColor: '#ffebee',
            color: '#c62828',
            fontFamily: 'system-ui, sans-serif'
          }}
        >
          <h2 style={{ marginTop: 0 }}>Something went wrong</h2>
          <p>The recorder hit an unexpected error and could not continue.</p>
          {this.state.message ? (
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>{this.state.message}</pre>
          ) : null}
          <button
            onClick={this.handleReload}
            style={{
              marginTop: '12px',
              padding: '8px 16px',
              backgroundColor: '#c62828',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
